import React from 'react'
import ReactDOM from 'react-dom'

import 'fontsource-montserrat/400.css'
import 'fontsource-montserrat/700.css'
import 'react-dates/initialize'

import 'moment/locale/fr'
import moment from 'moment'
import numbro from 'numbro'
import numbroFr from 'numbro/languages/fr-FR'

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

moment.locale('fr')

numbro.registerLanguage(numbroFr, true)
numbro.setLanguage('fr-FR', 'en-US')
numbro.setDefaults({ thousandSeparated: true })

ReactDOM.render(<App />, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
